import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getCheckEditableStart,
  getCheckEditableSuccess,
  getCheckEditableFailed,
} from "../redux/getPermissionEdit";

import { getCheckEditableApi } from "core/http/service/personnelInformation";

function* getCheckEditableWork() {
  try {
    const res = yield call(getCheckEditableApi);

    yield put({
      type: getCheckEditableSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getCheckEditableFailed.type,
    });
  }
}

function* watchGetCheckEditable() {
  yield takeLatest(getCheckEditableStart.type, getCheckEditableWork);
}

export default function* getCheckEditableSaga() {
  yield all([watchGetCheckEditable()]);
}
